import { render, staticRenderFns } from "./PopularProductOverview.vue?vue&type=template&id=291dc1e5&scoped=true&"
import script from "./PopularProductOverview.vue?vue&type=script&lang=js&"
export * from "./PopularProductOverview.vue?vue&type=script&lang=js&"
import style0 from "./PopularProductOverview.vue?vue&type=style&index=0&id=291dc1e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291dc1e5",
  null
  
)

export default component.exports